<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="OPSTINA.NAZIV.SINGULAR"></span></label> -->
              <div class="col-md-12">
                <yt-input
                  [Type]="'text'"
                  name="txtNaziv"
                  formControlName="Naziv"
                  #focusElement
                  [MaxLength]="100"
                  [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                  [Label]="'OPSTINA.NAZIV.SINGULAR'">
                </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                      <span *ngFor="let validation of errorMessages.Naziv">
                        <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>
              </div>
            </div>
            <div class="form-group row">
                <!-- <label class="col-form-label col-2"><span translate="OPSTINA.OKRUGID.SINGULAR"></span></label> -->
                <div class="col-md-12">
                    <!-- <yt-fw-dropdown
                    [ModelName]="'okrug'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]='true'
                    [Required]='true'
                    [Disabled]='false'
                    formControlName="OkrugID"
                    name="cmbOkrug"
                    [Type]="ID"
                    [ngClass]="{'is-invalid': submitted && fc.OkrugID.invalid}"
                    [Label]="'OPSTINA.OKRUGID.SINGULAR'">
                  </yt-fw-dropdown> -->
                  <yt-dropdown-picklist
                  [ModelName]="'okrug'"
                  [GetName]="'get'"
                  [ModelProperty]="'Naziv'"
                  [OrderBy]="'Naziv'"
                  [AllowAddNew]="true"
                  [AllowEdit]="true"
                  formControlName="OkrugID"
                  [Label]="'OPSTINA.OKRUGID.SINGULAR'"
                  >
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && fc.OkrugID.invalid">
                      <span *ngFor="let validation of errorMessages.OkrugID">
                        <span class="error-message" *ngIf="fc.OkrugID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </form>